const fareRulesToNumberMap = new Map<string, number>();
fareRulesToNumberMap.set("Not Allowed", 0);
fareRulesToNumberMap.set(undefined, 0);
fareRulesToNumberMap.set("", 0);
fareRulesToNumberMap.set("For Fee", 1);
fareRulesToNumberMap.set("Allowed", 2);

export { fareRulesToNumberMap };
